import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from 'shared/types/redux';
import { fetchAcceptPublicOffer } from '../../../services/joinOtaIndividual/fetchAcceptPublicOffer';
import type { IReceiptDetailsSaveRequest } from '../../../repositories/dailyrent/v1/receipt-details/save';
import { fetchSaveFormData } from '../../../services/joinOtaIndividual/fetchSaveFormData';
import { goToErrorStep, goToNextStep } from '../../../slices/joinOtaIndividual/stepsConfiguration';

export const saveFormAndAcceptOffer = createAsyncThunk<void, IReceiptDetailsSaveRequest, IThunkApi>(
  'joinOtaIndividual/saveFormAndAcceptOffer',
  async (params, thunkApi) => {
    const { dispatch, getState, extra: context } = thunkApi;

    try {
      await fetchSaveFormData(context, params);
      await fetchAcceptPublicOffer(context);

      dispatch(goToNextStep(getState().landingType));
    } catch (e) {
      dispatch(
        goToErrorStep({
          logger: context.logger,
          error: 'Ошибка при сохранении данных или подписании оферты для флоу циан /join-ota',
        }),
      );
    }
  },
);
